module.exports = __webpack_public_path__ + "static/media/nhp_vip.a5062cca.png";